export default "__VITE_ASSET__ylV0tAnx__"